import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { creditPackAsPublicQueryKeys } from "./creditPackAsPublicQueryKeys";

export function useQueryCreditPackListAsPublic(
  {
    api,
    opts,
  }: {
    api: ApiType;
    opts: Parameters<ApiType["public"]["creditPackApi"]["getList"]>[0];
  },
  {
    enabled,
  }: {
    enabled?: boolean;
  } = {
    enabled: true,
  },
) {
  return useQuery({
    queryKey: creditPackAsPublicQueryKeys.list(opts),
    queryFn: async () => {
      return (await api.public.creditPackApi.getList({ ...opts })).data;
    },
    enabled,
  });
}
